import { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery } from "@apollo/client";

import { conciergeShiftPerformance } from "./queries";
import { runnerShiftsQuery } from "../shifts/queries";
import { REFRESH_INTERVAL_MS } from "../constants";

/*
 * Per-runner parked and retrieved counts for one shift occurrence.
 */
export default function useShiftPerformance({ installationId }) {
  const [selection, setSelection] = useState(undefined);
  const [updatedAt, setUpdatedAt] = useState(null);

  const { data: shiftsData, loading: shiftsLoading, error: shiftsError } = useQuery(runnerShiftsQuery, {
    variables: { installationId },
    skip: !installationId,
    fetchPolicy: "cache-and-network",
  });

  const shifts = useMemo(
    () => (shiftsData?.runnerShifts ?? []).filter(Boolean),
    [shiftsData],
  );

  const { data, loading, error, refetch } = useQuery(conciergeShiftPerformance, {
    variables: { installationId, shiftId: selection },
    skip: !installationId,
    fetchPolicy: "cache-and-network",
    pollInterval: REFRESH_INTERVAL_MS,
    onCompleted: () => setUpdatedAt(new Date()),
  });

  const performance = data?.conciergeShiftPerformance ?? null;
  const isDefault = performance?.isDefault ?? false;

  useEffect(() => {
    if (isDefault) setSelection(undefined);
  }, [isDefault]);

  const resolved = performance ? performance.shiftId : selection;

  const select = useCallback((next) => setSelection(next), []);

  return {
    shifts,
    selection: resolved,
    runners: performance?.runners ?? [],
    loading: (loading || shiftsLoading) && !performance,
    updatedAt,
    error: error || shiftsError,
    select,
    refetch,
  };
}
